import { useCallback, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import CTAs from "../components/CTAs";

const NavigationPanelLP = ({ menuItems, logoSrc, onMenuItemClick }) => {
  const navigate = useNavigate();

  const handleLoginClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const handleSignUpClick = useCallback(() => {
    navigate("/selectaccount");
  }, [navigate]);

  // Mobile Nav
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
  };

  return (
    <div className="w-full relative bg-column-bg flex flex-row items-center justify-between box-border text-left text-base text-neutrals-neutral-900 font-open-sans-ff-meta-strong">
      <div className="hidden md:flex flex-row items-center justify-start gap-[82px]">
        <img
          className="w-[118px] relative h-10 object-cover"
          alt=""
          src="assets/logo-horizontal.svg"
        />
        <div className="flex flex-row items-start justify-start py-3 px-0 gap-[35px]">
          <div className="flex flex-row items-start justify-start">
            <div className="relative font-semibold">Home</div>
          </div>
          <div className="flex flex-row items-start justify-start">
            <div className="relative font-semibold">How it works</div>
          </div>
          <div className="flex flex-row items-start justify-start">
            <div className="relative font-semibold">Features</div>
          </div>
          <div className="flex flex-row items-start justify-start">
            <div className="relative font-semibold">Testimonial</div>
          </div>
          <div className="flex flex-row items-start justify-start">
            <div className="relative font-semibold">Pricing</div>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden w-full flex items-center justify-between px-4">
        <img
          className="w-[118px] relative h-10 object-cover"
          alt="Logo"
          src="assets/logo-horizontal.svg"
        />
        <button
          className="text-neutrals-neutral-900 focus:outline-none"
          onClick={toggleMobileMenu}
          aria-label="Toggle Mobile Menu"
        >
          {isMobileMenuOpen ? (
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-y-0 right-0 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
          isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full pt-16 px-6 space-y-6">
          {/* Close button */}
          <button
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
            onClick={toggleMobileMenu}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {/* Menu Items */}
          {["Home", "How it works", "Features", "Testimonial", "Pricing"].map(
            (item, index) => (
              <div
                key={index}
                className="text-lg font-semibold text-gray-800 hover:text-primary-primary-500 cursor-pointer"
                onClick={toggleMobileMenu}
              >
                {item}
              </div>
            )
          )}

          {/* Authentication Buttons */}
          <div className="flex flex-col space-y-4 pt-6">
            <div
              className="rounded-3xs bg-column-bg py-2.5 px-3.5 text-center cursor-pointer"
              onClick={handleLoginClick}
            >
              <div className="relative font-semibold">Login</div>
            </div>

            <div
              className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-primary-primary-500 py-2.5 px-3.5 text-center cursor-pointer text-neutrals-neutral-50"
              onClick={handleSignUpClick}
            >
              <div className="relative font-semibold">Sign up</div>
            </div>
          </div>
        </div>
      </div>

      {/* Login Btn */}
      <div className="flex flex-row items-start justify-start gap-2.5 text-sm">
        <div
          className="rounded-3xs bg-column-bg flex flex-row items-center justify-center py-2.5 px-3.5 cursor-pointer"
          onClick={handleLoginClick}
        >
          <div className="flex flex-row items-center justify-center">
            <div className="relative font-semibold">Login</div>
          </div>
        </div>

        {/* Sign up btn */}
        <div
          className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-primary-primary-500 flex flex-row items-center justify-center py-2.5 px-3.5 cursor-pointer text-neutrals-neutral-50"
          onClick={handleSignUpClick}
        >
          <div className="flex flex-row items-center justify-center">
            <div className="relative font-semibold">Sign up</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationPanelLP;
